import { useEffect } from "react";

export const useClickOutsideModalListener = (ref, callback) => {
  useEffect(() => {
    const wrappedCallback = (evt) => {
      if (ref.current && !ref.current.contains(evt?.target)) {
        callback();
      }
    };
    document.addEventListener("mouseup", wrappedCallback);
    return () => {
      document.removeEventListener("mouseup", wrappedCallback);
    };
  }, [ref]);
};
